var __TEMP__ = require('./_baseLt.js');var baseLt = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./_createRelationalOperation.js');var createRelationalOperation = __REQUIRE_DEFAULT__(__TEMP__);

/**
 * Checks if `value` is less than `other`.
 *
 * @static
 * @memberOf _
 * @since 3.9.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is less than `other`,
 *  else `false`.
 * @see _.gt
 * @example
 *
 * _.lt(1, 3);
 * // => true
 *
 * _.lt(3, 3);
 * // => false
 *
 * _.lt(3, 1);
 * // => false
 */
var lt = createRelationalOperation(baseLt);

if (!exports.__esModule) Object.defineProperty(exports, "__esModule", { value: true });exports.default = lt;
